import { useEffect } from 'react'

import { useCheckIntegrations } from '@/features/integrations/hooks/use-check-integrations'

import { useIsOwnerTenant } from '@/shared/auth/store'

import { useOnboardingActions, useOnboardingTask } from '../store'

/**
 * Custom Hook to check if the user has completed the onboarding tasks
 */

export const useCheckOnboardingTasks = () => {
	const isOwnerTenant = useIsOwnerTenant()

	const { markTaskComplete } = useOnboardingActions()
	const { hasIntegrations } = useCheckIntegrations()

	const setupIntegration = useOnboardingTask('setupIntegration')

	useEffect(() => {
		// Only check tasks on owner tenant
		if (!isOwnerTenant) return

		if (hasIntegrations && !setupIntegration?.completed) {
			markTaskComplete('setupIntegration')
		}
	}, [
		hasIntegrations,
		setupIntegration?.completed,
		markTaskComplete,
		isOwnerTenant,
	])
}
